// Shared billing math for the Invoice by Delivery surfaces (queue rows
// and the review detail page). Billing follows DELIVERED quantity; the
// fulfilled amount is shown alongside it to highlight the change.

// Minimal structural shape so both the queue and detail order-line types work.
type BillingLine = {
  deliveredQuantity?: number | null;
  fulfillmentQuantity?: number | null;
  unitCostCents: number;
};

export const formatDollars = (cents: number): string =>
  `$${(cents / 100).toFixed(2)}`;

// A "Fulfillment Delta" (PRD §4.2): the delivered quantity differs from the
// fulfilled quantity on this line. The presence of any such line is what holds
// an order for review.
export const lineHasDelta = (line: BillingLine): boolean =>
  (line.deliveredQuantity ?? 0) !== (line.fulfillmentQuantity ?? 0);

export const lineDeliveredCents = (line: BillingLine): number =>
  (line.deliveredQuantity ?? 0) * line.unitCostCents;

export const lineFulfilledCents = (line: BillingLine): number =>
  (line.fulfillmentQuantity ?? 0) * line.unitCostCents;

export const sumDeliveredCents = (lines: BillingLine[]): number =>
  lines.reduce((sum, line) => sum + lineDeliveredCents(line), 0);

export const sumFulfilledCents = (lines: BillingLine[]): number =>
  lines.reduce((sum, line) => sum + lineFulfilledCents(line), 0);
